var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"classroom-book"},[_c('div',{staticClass:"header"},[_c('Title',{attrs:{"name":"book"}}),_vm._v(" "),_c('img',{staticClass:"go-btn",attrs:{"src":_vm.$images.my_back_btn,"alt":"更多"}})],1),_vm._v(" "),_c('div',{staticClass:"content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }